export function FilterActions({
  canClear,
  onClear,
  onApply,
}: {
  canClear: boolean;
  onClear: () => void;
  onApply: () => void;
}) {
  return (
    <div className="flex justify-end gap-2 pt-1">
      <button
        type="button"
        onClick={onClear}
        disabled={!canClear}
        className="rounded-md px-3 py-1.5 text-sm text-gray-600 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-40"
      >
        Rimuovi
      </button>
      <button
        type="button"
        onClick={onApply}
        className="rounded-md bg-primary px-3 py-1.5 text-sm font-medium text-white hover:brightness-110"
      >
        Applica
      </button>
    </div>
  );
}
